/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ExtensionSessionResponse interface.
 */
export function instanceOfExtensionSessionResponse(value) {
    if (!('customToken' in value) || value['customToken'] === undefined)
        return false;
    if (!('uid' in value) || value['uid'] === undefined)
        return false;
    return true;
}
export function ExtensionSessionResponseFromJSON(json) {
    return ExtensionSessionResponseFromJSONTyped(json, false);
}
export function ExtensionSessionResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'customToken': json['custom_token'],
        'expiresIn': json['expires_in'] == null ? undefined : json['expires_in'],
        'uid': json['uid'],
    };
}
export function ExtensionSessionResponseToJSON(json) {
    return ExtensionSessionResponseToJSONTyped(json, false);
}
export function ExtensionSessionResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'custom_token': value['customToken'],
        'expires_in': value['expiresIn'],
        'uid': value['uid'],
    };
}
